import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { dismissUpgradeVersion } from '../apis';

const useDismissUpgradeAppInstance = () => {
  const mutationAction = useMutation({
    mutationFn: dismissUpgradeVersion,
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error dismiss upgrade:', error);
    },
  });

  return mutationAction;
};

export default useDismissUpgradeAppInstance;
